var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "well page"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('h2', [_vm._v("Store Selection")]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "showMsg"
    }
  }), _vm._v(" "), _c('p', [_vm._v("Select the appropriate store you would like to file an issue for.")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search_query),
      expression: "search_query"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "search",
      "placeholder": "Filter Stores..."
    },
    domProps: {
      "value": (_vm.search_query)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.search_query = $event.target.value
      }
    }
  }), _vm._v(" "), _c('br')]), _vm._v(" "), _vm._l((Math.ceil(_vm.stores.length / 3)), function(i) {
    return _c('div', {
      staticClass: "row"
    }, _vm._l((_vm.stores.slice((i - 1) * 3, i * 3)), function(store) {
      return _c('div', {
        staticClass: "col-md-4"
      }, [_c('div', {
        staticClass: "panel panel-primary hvr-grow hvr-fix clickable",
        on: {
          "click": function($event) {
            _vm.select_store(store)
          }
        }
      }, [_c('div', {
        staticClass: "panel-heading"
      }, [(store.franchise_name) ? _c('h3', {
        staticClass: "panel-title"
      }, [_vm._v(_vm._s(store.name) + " - " + _vm._s(store.franchise_name))]) : _vm._e(), _vm._v(" "), (!store.franchise_name) ? _c('h3', {
        staticClass: "panel-title"
      }, [_vm._v(_vm._s(store.name))]) : _vm._e()]), _vm._v(" "), _c('div', {
        staticClass: "panel-body"
      }, [_vm._v("\n          " + _vm._s(store.address) + " "), _c('br'), _vm._v("\n          " + _vm._s(store.state_name) + "\n        ")])])])
    }))
  }), _vm._v(" "), (!_vm.stores.length) ? _c('div', {
    staticClass: "row"
  }, [_c('strong', {
    staticClass: "text-danger"
  }, [_vm._v("No stores found - try using the store address or suburb")])]) : _vm._e()], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-105f3fae","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./assets/vue/logger/StoreList.vue
// module id = 530
// module chunks = 0